/* eslint-disable class-methods-use-this */
import {
  Extension,
  accessResponse,
  basicResponse,
  command,
  durtApiResponseType,
  extensionResponseType,
  infoResponse,
} from 'client/services/durtConstants';
import { digest, makePkceCode } from 'client/util/pkceGenerator';
import { sendMessageToChromeExtension } from 'client/util/message';
import api from 'client/api';

const { user: userApi } = api;

export const extensions: {[name: string]: Extension} = {
  chrome: {
    id: 'jdoahkhfkeipblhbhppmcbdgapeoaopa',
    send: sendMessageToChromeExtension,
  },
};

export class DurtService {
  private extension: Extension | undefined;

  async getInfo():Promise<infoResponse> {
    const info = await this.sendMessage<infoResponse>({ cmd: command.info });

    const validResults = [
      durtApiResponseType.success,
      durtApiResponseType.userNotRegisteredError,
    ];

    if (validResults.includes(info.result)) {
      return info;
    }
    throw new Error(info.result);
  }

  async signin(): Promise<void> {
    const pkceKey = makePkceCode();
    const pkceChallenge = await digest(pkceKey);

    const access = await this.sendMessage<accessResponse>({
      cmd: command.access,
      pkce: pkceChallenge,
    });

    if (access.result === durtApiResponseType.success) {
      await userApi.loginDURT({
        sessionToken: access.session,
        sessionTokenCode: pkceKey,
      });
    } else if (access.result === durtApiResponseType.userNotRegisteredError) {
      // @TODO: what do we do here?
    } else {
      throw new Error(access.result);
    }
  }

  async register(idToken:string): Promise<void> {
    const registerResponse = await this.sendMessage<basicResponse>({
      cmd: command.register,
      token: idToken,
    });

    if (registerResponse.result !== durtApiResponseType.success) {
      throw new Error(registerResponse.result);
    }
  }

  async hasExtension(): Promise<boolean> {
    try {
      if (!this.extension) {
        this.extension = await this.getExtension();
      }
      return true;
    } catch (err) {
      return false;
    }
  }

  private async sendMessage<T>(payload: any) {
    if (!this.extension) {
      this.extension = await this.getExtension();
    }

    return this.extension.send<T>(this.extension.id, payload);
  }

  private async getExtension() {
    if (await this.hasChomeExtension()) {
      return extensions.chrome;
    }

    throw new Error('durt extension error: not found');
  }

  private async hasChomeExtension() {
    try {
      const response = await extensions.chrome.send<basicResponse>(extensions.chrome.id, { cmd: 'be_version' });
      return response.result === extensionResponseType.success;
    } catch (error) {
      return false;
    }
  }
}

// DurtService Singleton
export default new DurtService();
